import React, { ReactNode } from "react";
import { buttonStyles } from "../styles";

interface ButtonProps {
  children: ReactNode;
  onClick: () => void;
  variant?: "primary" | "icon";
  className?: string;
  disabled?: boolean;
  title?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = "primary",
  className = "",
  disabled = false,
  title,
}) => {
  const baseStyle = buttonStyles[variant] || buttonStyles.primary;

  return (
    <button
      onClick={onClick}
      className={`${baseStyle} ${className}`}
      disabled={disabled}
      title={title}
      aria-label={title}
    >
      {children}
    </button>
  );
};

export default Button;
